/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
  InputNumber,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import { CheckCircleOutlined } from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import { getTiposDeContrataciones } from 'api/catalogos/tiposDeContrataciones';
import {
  getPrestacionesNombramientos,
  postPrestacionNombramiento,
  deletePrestacionNombramiento,
  patchPrestacionNombramiento,
  getPrestacionNombramiento,
  autorizarPrestacionNombramiento,
} from 'api/catalogos/NombramientosPrestaciones';
import ModalConfirmation from 'components/ModalConfirmation';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';

export const presentacionparanombramientoPermission = {
  permissionModel: 'presentacionparanombramiento',
};

const NombramientosPrestaciones = ({ permission }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [, setEstatusInactivo] = useState(false);
  const [, setEstatusAutorizado] = useState(false);
  const [, setEstadosFiltered] = useState([]);
  const [tiposDeContrataciones, setTiposDeContrataciones] = useState([]);
  const [selectedData] = useState({});

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getPrestacionesNombramientos();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _tiposDeContrataciones,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposDeContrataciones(),
        getPrestacionesNombramientos(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setData(formatReceived(_data));
        setTiposDeContrataciones((_tiposDeContrataciones));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    // setDisableFields(false);
    setSelectedRowKeys([]);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _nombramiento = await getPrestacionNombramiento(match.id);
    if (_nombramiento?.estados_globales === ESTATUS_ACTIVO
      || _nombramiento?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
      || estado?.id === ESTATUS_ACTIVO));
    }
    if (_nombramiento?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_nombramiento?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }

    if (_nombramiento) {
      form.setFieldsValue({
        ...formatReceived(_nombramiento),
        // vigencia_inicial: _nombramiento.vigencia_inicial
        //   ? new Moment(_nombramiento.vigencia_inicial, 'YYYY-MM-DD')
        //   : null,
        // vigencia_final: _nombramiento.vigencia_final
        //   ? new Moment(_nombramiento.vigencia_final, 'YYYY-MM-DD')
        //   : null,

      });
      formDatos.setFieldsValue(formatReceived(_nombramiento));
      setVisible(true);
      formatReceived(_nombramiento);
    }

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      values.vigencia_inicial = values.vigencia_inicial ? values.vigencia_inicial.format('YYYY-MM-DD') : null;
      values.vigencia_final = values.vigencia_final ? values.vigencia_final.format('YYYY-MM-DD') : null;
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchPrestacionNombramiento(key, values) : postPrestacionNombramiento(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePrestacionNombramiento(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar el nombramiento');
        return;
      }
      const saved = await autorizarPrestacionNombramiento(key);
      if (saved) {
        const _data = await getPrestacionesNombramientos();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 400,
    },
    {
      titleText: 'Tipo de Contratación',
      dataIndex: 'tipos_de_contratacion',
      key: 'tipos_de_contratacion',
      render: (val) => (Array.isArray(val)
        ? val.map((id) => tiposDeContrataciones.find((e) => e.id === id)?.descripcion || 'No encontrada').join(', ')
        : 'No encontrada'),
      width: 150,
    },
    {
      titleText: 'Vigencia Inicial',
      dataIndex: 'vigencia_inicial',
      key: 'vigencia_inicial',
      render: (val) => (val ? val.format(DATE_FRONTEND_FORMAT) : ''),
      width: 100,
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      render: (val) => (val ? val.format(DATE_FRONTEND_FORMAT) : ''),

      width: 100,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
    vigencia_final: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const vigenciaInicial = getFieldValue('vigencia_inicial');
          if (!value || !vigenciaInicial) {
            return Promise.resolve();
          }
          if (value.isSameOrAfter(vigenciaInicial, 'day')) {
            return Promise.resolve();
          }
          return Promise.reject(new Error('La vigencia final no puede ser anterior a la vigencia inicial'));
        },
      }),
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
            // onClickActivate,
            // onClickDeactivate,
          }}
          // allowActivate
          // allowDeactivate
          customActions={[
            {
              onClick: () => setConfirmationVisible(true),
              permission: { model: 'presentacionparanombramiento', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length
                            || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                            // || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                            || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          filterNested
        />
        <Modal
          open={open}
          width="30%"
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Prestaciones para Nombramientos`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
             )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="descripcion"
                  label="Descripción"
                  hasFeedback
                  rules={rules.required}

                >
                  <Input
                    dataSource={data}
                    disabled={
                      form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                      || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="tipos_de_contratacion"
                  label="Tipo de Contratación"
                  rules={rules.required}
                  hasFeedback

                >
                  <Select
                    mode="multiple"
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={tiposDeContrataciones}
                    disabled={
                      form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                      || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>

                <Form.Item
                  name="vigencia_inicial"
                  label="Vigencia Inicial"
                  rules={rules.required}
                  hasFeedback
                >

                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    placeholder="Seleccione una fecha"
                    disabled={
                      form.getFieldValue('estados_globales') === ESTATUS_AUTORIZADO
                      || form.getFieldValue('estados_globales') === ESTATUS_INACTIVO
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>

                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                  rules={rules.vigencia_final}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    placeholder="Seleccione una fecha"
                    disabled={form.getFieldValue('estados_globales') !== ESTATUS_AUTORIZADO}

                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>

            </Row>

          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="El Registro Seleccionado"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar la Jornada ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default NombramientosPrestaciones;
